<div *ngIf="areButtonsVisible" class="absolute bottom-2.5 left-58 flex flex-col z-500">
  <mapm-icon [isActiveOnHover]="true" [isTooltipVisible]="false"
             containerClasses="rounded-t-md" icon="tk-i-plus-black" isActiveIcon="tk-i-plus-white"
             iconClasses="w-3 h-3" (click)="onZoomIn()"></mapm-icon>

  <mapm-icon [isActiveOnHover]="true" [isTooltipVisible]="false"
             containerClasses="" icon="bg-center tk-i-minus-black" isActiveIcon="bg-center tk-i-minus-white"
             iconClasses="w-3 h-3" (click)="onZoomOut()"></mapm-icon>
</div>
